(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hah-nattokinase-price-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    const dataElement = document.getElementById('hah-price-preview-data');
    if (!dataElement) return;
    let data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (_) {
      return;
    }
    const page = document.querySelector(`product-page[data-id="${data.productId}"]`);
    if (!page || page.dataset.hahPreviewInitialized) return;
    page.dataset.hahPreviewInitialized = 'true';
    const variants = new Map(data.variants.filter(v => v.count > 0 && v.unitPrice).map(v => [String(v.id), v]));
    if (variants.size !== 4) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        render();
      });
    });
    const watch = () => observer.observe(page, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-variant-id'] });
    const make = (tag, className, text) => {
      const el = document.createElement(tag);
      el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    };
    const write = (el, text) => {
      if (el.textContent !== text) el.textContent = text;
    };
    const findOrAdd = (parent, tag, className) => {
      let el = parent.querySelector(`.${className}`);
      if (!el) {
        el = make(tag, className);
        parent.append(el);
      }
      return el;
    };
    function render() {
      observer.disconnect();
      try {
        const form = page.querySelector('#new-form');
        const options = form ? Array.from(form.querySelectorAll('.new-form-option[data-variant-id]')) : [];
        if (options.length !== 4 || options.some(el => !variants.has(el.dataset.variantId) || !el.querySelector('.value-right'))) {
          page.removeAttribute('data-hah-price-preview');
          return;
        }
        for (const option of options) {
          const variant = variants.get(option.dataset.variantId);
          const content = option.querySelector('.value-right');
          write(findOrAdd(content, 'span', 'hah-pack-quantity'), variant.quantityLabel);
          const pricing = findOrAdd(content, 'span', 'hah-pack-pricing');
          write(findOrAdd(pricing, 'strong', 'hah-pack-unit'), variant.unitPrice);
          write(findOrAdd(pricing, 'span', 'hah-pack-per'), data.perBottle);
          write(findOrAdd(pricing, 'span', 'hah-pack-total'), `${data.totalLabel} ${variant.totalPrice}`);
          option.setAttribute('role', 'radio');
          option.setAttribute('tabindex', '0');
          option.setAttribute('aria-checked', String(option.classList.contains('selectedWB')));
          const offerMessage = (["39406574764184","39376759324824","39407071592600","39407125889176","39406781530264","39407225798808","42270468899064","41063986135192","42214974390520","43652741497097","43709871948041","50140233335049"].includes(option.dataset.variantId) ? 'BESTSELLER' : '') || option.querySelector('.corner-offer')?.textContent?.trim() || (option.classList.contains('diagonal-offer') ? option.style.getPropertyValue('--message').trim().replace(/^['"]|['"]$/g, '') : '');
          option.setAttribute('aria-label', `${offerMessage ? offerMessage + ', ' : ''}${variant.title}, ${variant.quantityLabel}, ${variant.unitPrice} ${data.perBottle}, ${data.totalLabel} ${variant.totalPrice}`);
          if (!option.dataset.hahKeyboard) {
            option.dataset.hahKeyboard = 'true';
            option.addEventListener('keydown', event => {
              if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                option.click();
              }
            });
          }
        }
        const heading = form.querySelector('#title-offer-WB');
        if (heading) write(heading, data.heading);
        const selected = options.find(el => el.classList.contains('selectedWB'));
        if (!selected) return;
        const variant = variants.get(selected.dataset.variantId);
        let summary = form.querySelector('.hah-selected-price');
        if (!summary) {
          summary = make('div', 'hah-selected-price');
          summary.setAttribute('aria-live', 'polite');
          form.prepend(summary);
        }
        write(findOrAdd(summary, 'strong', 'hah-selected-unit'), variant.unitPrice);
        write(findOrAdd(summary, 'span', 'hah-selected-per'), data.perBottle);
        write(findOrAdd(summary, 'span', 'hah-selected-total'), `${variant.title} · ${variant.quantityLabel} · ${data.totalLabel} ${variant.totalPrice}`);
        const measurement = findOrAdd(summary, 'span', 'hah-selected-measurement');
        write(measurement, variant.basePrice || '');
        measurement.hidden = !variant.basePrice;
        page.setAttribute('data-hah-price-preview', 'true');
        document.querySelectorAll('.sticky-add-to-cart__price').forEach(sticky => {
          const replacement = findOrAdd(sticky, 'span', 'hah-sticky-price');
          write(findOrAdd(replacement, 'span', 'hah-sticky-unit'), `${variant.unitPrice} ${data.perBottle}`);
          write(findOrAdd(replacement, 'small', 'hah-sticky-total'), `${data.totalLabel} ${variant.totalPrice}`);
          sticky.setAttribute('data-hah-sticky-preview', 'true');
        });
      } finally {
        watch();
      }
    }
    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
